import { defineStore } from 'pinia'

type Issue442AbTestResult = {
  isAPattern: boolean
  isBPattern: boolean
}

export const useIssue442AbTestStore = defineStore('ab_test_issue_442', () => {
  const abTestResult = ref<Issue442AbTestResult | null>(null)

  return {
    abTestResult
  }
})
